import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { ASSIGNMENT_QUEUE_BASE_PATH } from '../constants/assignmentQueueBasePath';
import { AssignmentQueue } from '../types/AssignmentQueue';

export const getAssignmentQueues = async (
  constructGet: ConstructGet,
  documentType: string,
): Promise<NonPaginatedResponse<AssignmentQueue[]> | undefined> =>
  constructGet<NonPaginatedResponse<AssignmentQueue[]>>(
    ASSIGNMENT_QUEUE_BASE_PATH,
    {
      params: { document_type: documentType },
    },
    { preventDefaultErrorToast: true },
  );
